export const ACCESS_STATUS_PENDING = 'pending';
export const ACCESS_STATUS_APPROVED = 'approved';
export const ACCESS_STATUS_REVOKED = 'revoked';

export const BOOTSTRAP_APPROVED_EMAILS = [
  'tyson@tysonphillipslaw.com',
];

export const normalizeAccessEmail = (value) => (value || '').trim().toLowerCase();

export const isBootstrapApprovedEmail = (value) =>
  BOOTSTRAP_APPROVED_EMAILS.includes(normalizeAccessEmail(value));

export const getInitialAccessStatus = (email) =>
  isBootstrapApprovedEmail(email) ? ACCESS_STATUS_APPROVED : ACCESS_STATUS_PENDING;

export const isApprovedAccessStatus = (value) => value === ACCESS_STATUS_APPROVED;
export const isRevokedAccessStatus = (value) => value === ACCESS_STATUS_REVOKED;
